import React from 'react';
import classNames from 'classnames';
import styles from './download-button.module.scss';
import { Button, Tooltip } from '@mui/material';
import ImageRoundedIcon from '@mui/icons-material/ImageRounded';

interface DownloadButtonProps {
    fileName: string;
    downloadUrl?: string;
    downloadFileName?: string;
    truncate?: boolean;
    preserveExtensionOnTruncate?: boolean;
    className?: string;
    wrapperClassName?: string;
}

const DownloadButton: React.FC<DownloadButtonProps> = ({
    fileName,
    downloadUrl,
    downloadFileName,
    truncate = true,
    preserveExtensionOnTruncate = false,
    className,
    wrapperClassName,
}) => {
    const extensionSeparatorIndex = fileName.lastIndexOf('.');
    const hasExtension = extensionSeparatorIndex > 0 && extensionSeparatorIndex < fileName.length - 1;
    const fileBaseName = hasExtension ? fileName.slice(0, extensionSeparatorIndex) : fileName;
    const fileExtension = hasExtension ? fileName.slice(extensionSeparatorIndex) : '';

    return (
        <Tooltip title={fileName}>
            <span className={wrapperClassName}>
                <Button
                    {...(
                        downloadUrl
                            ? {
                                component: 'a' as const,
                                href: downloadUrl,
                                download: downloadFileName ?? fileName,
                            }
                            : { type: 'button' as const }
                    )}
                    className={classNames(
                        styles.downloadButton,
                        {
                            [styles.fullWidth]: !truncate,
                        },
                        className
                    )}
                    disabled={!downloadUrl}>
                    <ImageRoundedIcon className={styles.icon} />
                    <div
                        className={classNames(styles.fileName, {
                            [styles.fileNameFull]: !truncate,
                            [styles.fileNameWithExtension]: truncate && preserveExtensionOnTruncate && hasExtension,
                        })}>
                        {truncate && preserveExtensionOnTruncate && hasExtension ? (
                            <>
                                <span className={styles.fileNameBase}>{fileBaseName}</span>
                                <span className={styles.fileNameExtension}>{fileExtension}</span>
                            </>
                        ) : (
                            fileName
                        )}
                    </div>
                </Button>
            </span>
        </Tooltip>
    );
};

export default DownloadButton;
